import { render, staticRenderFns } from "./Dot.vue?vue&type=template&id=7d75253c&"
import script from "./Dot.vue?vue&type=script&lang=js&"
export * from "./Dot.vue?vue&type=script&lang=js&"
import style0 from "./Dot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports